import { z } from 'zod'

export const STRATALYST_DASHBOARD_COUNTS_CONTRACT_VERSION = '1.0.0' as const
export const stratalystDashboardCountsResponseSchema = z.unknown()
export type StratalystDashboardCountsResponse = z.infer<typeof stratalystDashboardCountsResponseSchema>
